import React, { useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { toggleCompare } from "../../store/ducks/compare";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

import { CartItem, Location, OptionalServices, Product, Stock } from "../../models/app";
import {
  Box,
  Dialog,
  DialogContent,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  InputAdornment,
  Typography,
  Popover
} from "@mui/material";
import { addToCart } from "../../store/ducks/app";
import { useGetAdditionalServices } from "../../hooks/useGetAdditionalServices";
import { useCart } from "../../hooks/useCart";
import { RootState } from "../../store/ducks";
import ReactHtmlParser from "react-html-parser";
import ClearIcon from "@mui/icons-material/Clear";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Alert from "../../components/UI/alert/Alert";
import OptionalServicesModal from "../../components/modal/OptionalServicesModal";
import { Helmet } from "react-helmet";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import {
updateSelectedLocation,
updateUserSystemId,
} from "../../store/ducks/app";
import { GetAdditionalServices } from "../../services/GetAdditionalServices";
import { clearCart } from "../../store/ducks/app";
interface TireDetailsPageProps {
  item: Product;
  showExternal: boolean;
  handleAddToCart?: (item: any) => void;
  getLocationsQuantities: (product: Product, location?: Location, showExternal?: boolean) => Stock[];
}


const TireDetailsPage: React.FC<TireDetailsPageProps> = ({ item, getLocationsQuantities, showExternal }: TireDetailsPageProps) => {
  const [searchParams] = useSearchParams();
  const increaseQuantity = () => {
    setQuantity(quantity + 1);
  };
  const customerId = useSelector((state: RootState) => state.store.userSystemId);
  const [warehouseAnchorEl, setWarehouseAnchorEl] =
    useState<HTMLElement | null>(null);

  const isWarehouseHoverOpen = Boolean(warehouseAnchorEl);


  const decreaseQuantity = () => {
    if (quantity > 0) {
      setQuantity(quantity - 1);
    }
  };
  const dispatch = useDispatch();
  const compareItems = useSelector((state: RootState) => state.compare.items);
  const isCompared = compareItems.some(x => x.SystemId === item.SystemId);
  const navigate = useNavigate();

  const locationsStore = useSelector((state: RootState) => state?.store?.locations);
  const selectedLocationStore = useSelector((state: RootState) => state?.store?.selectedLocation);
  const userSystemIdStore = useSelector((state: RootState) => state?.store?.userSystemId);

  const [locations, setLocations] = useState<Location[]>(locationsStore);
  const [selectedLocation, setSelectedLocation] = useState<Location | null>(selectedLocationStore);
  const [userSystemId, setUserSystemId] = useState(userSystemIdStore);
  const [descriptionTab, setDescriptionTab] = useState("tab");
  const [specsTab, setSpecsTab] = useState("tab");
  const [reviewsTab, setReviewsTab] = useState("tab");
  const [activeTab, setActiveTab] = useState(false);
  const [activeTabClass, setActiveTabClass] = useState("tab-btn active-btn p_relative d_iblock fs_18 font_family_inter lh_20 float_left fw_medium z_1 mr_35 tran_5");
  const [nonActiveTabClass, setNonActiveTabClass] = useState("tab-btn p_relative d_iblock fs_18 font_family_inter lh_20 float_left fw_medium z_1 mr_35 tran_5");
  const [quantity, setQuantity] = useState(JSON.parse(searchParams?.get("searchInputRear") ?? `""`).Width != "" || JSON.parse(searchParams?.get("searchInputRear") ?? `""`).RawSize != "" ? 2 : 4);
  const [options, setOptions] = useState<OptionalServices[]>([]);

  const [open, setOpen] = useState(false);
  const [stock, setStock] = useState<Stock[]>(getLocationsQuantities(item));
  const initialLocationIndex = stock.findIndex((oneStock: Stock) => oneStock.locationObj.guestCutomerId === selectedLocation?.guestCutomerId).toString();
  const [locationQuantity, setLocationQuantity] = useState<string>(initialLocationIndex);

  // const [stock, setStock] = useState<Stock[]>([]);

  // const [locationQuantity, setLocationQuantity] = useState<string>("0");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const totalQuantity = stock
    //.filter(currentStock => !currentStock.externalInventory) // Exclude items where external is true
    .reduce((acc, currentStock) => acc + currentStock.qty, 0);
  const [newCartItem, setNewCartItem] = useState<CartItem>(
    {
      locationCode: selectedLocation?.code ?? selectedLocationStore?.code,
      id: item?.SystemId ?? "",
      no: item?.No ?? "",
      name: item?.Model ?? "Product Name",
      quantity: quantity ?? 0,
      image: item?.Image_Source ?? "../../assets/images/product/blog-1.jpg",
      description: item?.Description ?? "",
      brand: item?.Brand ?? "",
      price: item?.UnitPrice ?? 0,
      salesTax: item?.salesTax,
      additionalTax1: item?.additionalTax1,
      additionalTax2: item?.additionalTax2,
      additionalTax1Caption: item?.additionalTax1Caption,
      additionalTax2Caption: item?.additionalTax2Caption,
      showMessage: item[selectedLocationStore.locationCaption.charAt(0).toUpperCase() + selectedLocationStore.locationCaption.slice(1) + "Qty"] == 0,

      services: []
    });


  const { optionalServices } =
    useGetAdditionalServices(item?.SystemId, `1`, "");

  const { totalPrice, updateCart, cartItems, setCartItems, calculateTotal, removeFromCart } =
    useCart(false);

  const cart = useSelector((state: RootState) => state?.store?.cart);
  const user = useSelector((state: RootState) => state?.store?.user);

  const isUser = (user !== "" && user !== "guest")




  useEffect(() => {
    // var items= getLocationsQuantities(item,undefined,showExternal);
    // setStock(items);
    // (oneStock.locationObj.guestCutomerId !== stock[parseInt(locationQuantity, 10)]?.locationObj.guestCutomerId) &&
    // <MenuItem key={index} disabled={oneStock.qty === 0}
    //           value={index.toString()} style={{cursor: "default"}}>
    //     {oneStock.locationObj.name} ( {oneStock.qty ?? 0} )
    // </MenuItem>
    // var newStockData = getLocationsQuantities(item,undefined,showExternal);
    //  setStock([...newStockData]);
    buttonState(item, selectedLocationStore);

  }, [selectedLocationStore, cart]);

  // const openReviews = () =>{
  //     if(reviewsTab === "tab active-tab"){
  //         setActiveTab(false);
  //         setReviewsTab("tab");
  //     }
  //     else{
  //         setActiveTab(true);
  //         setReviewsTab("tab active-tab");
  //     }
  //     setDescriptionTab("tab");
  //     setSpecsTab("tab");
  // }

  const handleImageClick = () => {
    setImageModalOpen(true);
  };

  const openDescription = () => {
    if (descriptionTab === "tab active-tab") {
      setActiveTab(false);
      setDescriptionTab("tab");
    } else {
      setActiveTab(true);
      setDescriptionTab("tab active-tab");
    }
    setReviewsTab("tab");
    setSpecsTab("tab");
  }

  const openSpecs = () => {
    if (specsTab === "tab active-tab") {
      setActiveTab(false);
      setSpecsTab("tab");
    } else {
      setActiveTab(true);
      setSpecsTab("tab active-tab");
    }
    setReviewsTab("tab");
    setDescriptionTab("tab");
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newQuantity = parseInt(event.target.value);
    if (!isNaN(newQuantity) && newQuantity > 0) {
      setQuantity(newQuantity);
    }
    // console.log(newQuantity);
  };

  const handleWareHouseChange = (event: SelectChangeEvent<string>) => {
    // const selectedIndex = parseInt(event.target.value, 10);
    // if (isNaN(selectedIndex)) return;

    // const selectedStock = stock[selectedIndex];

    // localStorage.setItem("location", JSON.stringify(selectedStock.locationObj));

    // dispatch(updateSelectedLocation(selectedStock.locationObj));
    // dispatch(updateUserSystemId(selectedStock.locationObj.guestCutomerId));

    // setLocationQuantity(event.target.value);
    // setIsWarehouseOpen(false); // ✅ close AFTER selection
  };


  const handleAddServices = () => {
    //   const cart: CartItem[] = JSON.parse(localStorage.getItem("cart") ?? "[]");
    //   if ((user === "" || user === "guest" )) {
    //       setOpen(true);
    //       setError(false);
    //   } else {

    // console.log(" else ");

    if ((cart.length === 0) || ((cart.length > 0) && (selectedLocationStore) && (selectedLocationStore?.code === cart[0].locationCode))) {

      const newItem: CartItem = {
        locationCode: selectedLocationStore?.code,
        id: item?.SystemId ?? "",
        no: item?.No ?? "",
        showMessage: item[selectedLocationStore.locationCaption.charAt(0).toUpperCase() + selectedLocationStore.locationCaption.slice(1) + "Qty"] == 0,
        name: item?.Model ?? "Product Name",
        quantity: quantity ?? 0,
        image: (item?.Image_Source && item?.Image_Source?.length > 0) ? item?.Image_Source : "../../assets/images/product/blog-1.jpg",
        description: item?.Description ?? "",
        price: item?.UnitPrice ?? 0,
        services: [],
        brand: item?.Brand ?? "",
        salesTax: item?.salesTax ?? "",
        additionalTax1: item?.additionalTax1 ?? "",
        additionalTax1Caption: item?.additionalTax1Caption ?? "",
        additionalTax2: item?.additionalTax2 ?? "",
        additionalTax2Caption: item?.additionalTax2Caption ?? ""
      };
      // console.log(" 1 ", item, newItem);


      // if(process.env.REACT_APP_WHOLESALE_FLAG =="false"){
      //    const selectedServices = optionalServices?.filter(
      //   (w) => w.Selected === true
      // );
      dispatch(addToCart({
        ...newItem,
        services: optionalServices ?? []
      }));
      navigate('/cart')
      // }


      // else setOpen(true);
    } else {
      dispatch(clearCart());
      const newItem: CartItem = {
        locationCode: selectedLocationStore?.code,
        id: item?.SystemId ?? "",
        no: item?.No ?? "",
        showMessage: item[
          selectedLocationStore.locationCaption.charAt(0).toUpperCase() +
          selectedLocationStore.locationCaption.slice(1) +
          "Qty"
        ] == 0,
        name: item?.Model ?? "Product Name",
        quantity: quantity ?? 0,
        image: (item?.Image_Source && item?.Image_Source?.length > 0)
          ? item?.Image_Source
          : "../../assets/images/product/blog-1.jpg",
        description: item?.Description ?? "",
        price: item?.UnitPrice ?? 0,
        services: optionalServices ?? [],
        brand: item?.Brand ?? "",
        salesTax: item?.salesTax ?? "",
        additionalTax1: item?.additionalTax1 ?? "",
        additionalTax1Caption: item?.additionalTax1Caption ?? "",
        additionalTax2: item?.additionalTax2 ?? "",
        additionalTax2Caption: item?.additionalTax2Caption ?? ""
      };

      dispatch(addToCart({
        ...newItem,
        services: optionalServices ?? []
      }));
      navigate('/cart');

    }
    // }


    // if(quantity <= stock[parseInt(locationQuantity, 10)]?.qty){
    // }
    // else{
    //     quantity === 0? setErrorMessage("Please Select Number Of Tires Needed") : setErrorMessage("Not Enough In Stock");
    //     setError(true);
    // }
  }

  const buttonState = (item: Product, location?: Location): string => {
    const cart: CartItem[] = JSON.parse(localStorage.getItem("cart") ?? "[]");
    // if(stock.every((onestock:Stock)=>onestock.qty === 0)){
    //     return "OUT OF STOCK";
    // }
    // else

    if ((cart.length === 0) || ((cart.length > 0) && (selectedLocationStore) && (selectedLocationStore?.code === cart[0].locationCode))) {
      if ((cart.length > 0) && (cart.find(item1 => item1.id === item.SystemId))) {
        return "ADDED TO CART";
      }
    }
    return process.env.REACT_APP_WHOLESALE_FLAG == "true" ? "ADD TO CART" : "SEE OUT-THE-DOOR PRICE";
  };

  const styles = {
    leftTriangle: {
      width: '0',
      height: '0',
      borderStyle: 'solid',
      borderWidth: '0px 20px 14px 0px',
      borderColor: 'transparent rgb(28.5, 99, 30) transparent transparent',
      zIndex: 2
    },
    rightTriangle: {
      width: '0',
      height: '0',
      borderStyle: 'solid',
      borderWidth: '0px 0 14px 20px',
      borderColor: 'transparent transparent transparent rgb(28.5, 99, 30)',
      zIndex: 2
    }
  };

  const parseHTML = (htmlString: string) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };

  return (<Grid container spacing={1} xs={12}

  ><Helmet>
      <meta property="og:title" content={item.Model} />
      <meta property="og:description" content={`Check out the details of ${item.Model} at TireZone`} />
      <meta property="og:image" content={item.Image_Source ?? "../../assets/images/no-image-icon-23485.png"} />
      <meta property="og:url" content="http://tirezone.co" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={item.Model} />
      <meta name="twitter:description" content={`Check out the details of ${item.Model} at TireZone`} />
      <meta name="twitter:image" content={item.Image_Source ?? "../../assets/images/no-image-icon-23485.png"} />
    </Helmet>
    {(item.modelOfferText && item.modelOfferText.length > 0) && <>
      <Grid item xs={12} sx={{
        height: "45px",
        backgroundColor: "rgb(38, 132, 40)",
        color: "rgb(255, 255, 255)",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px !important"
      }}>

        {ReactHtmlParser(item.modelOfferText)}

      </Grid>
      <Grid item xs={12} sx={{
        height: "25px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: "0px !important"
      }}>
        <div style={styles.leftTriangle}></div>
        <div style={styles.rightTriangle}></div>
      </Grid>
    </>}
    <Grid item mt={2} xs={5} lg={2} style={{ textAlign: 'center' }} px={{ xs: 1, lg: 0 }}>
      <img src={item.Image_Source ?? require("../../assets/images/no-image-icon-23485.png")}
        alt={item.Model}
        style={{ width: "auto", height: "100px", cursor: "pointer", marginBottom: "10px" }}
        onClick={handleImageClick} />
      <Dialog open={imageModalOpen} onClose={() => setImageModalOpen(false)}>
        <DialogContent sx={{ overflow: "hidden", width: "400px", height: "400px", position: "relative" }}>
          <IconButton
            style={{ position: "absolute", top: 0, right: 0, zIndex: 1 }}
            onClick={() => setImageModalOpen(false)}
          >
            <ClearIcon />
          </IconButton>
          <div style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
            <img
              src={item.Image_Source ?? require("../../assets/images/no-image-icon-23485.png")}
              alt={item.Model}
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            />
          </div>
        </DialogContent>
      </Dialog>
    </Grid>
    <Grid item xs={7} lg={2} pr={{ md: 1 }}>
      {item.brand_image_source ? <img src={item.brand_image_source} alt="Model's Logo"
        style={{ width: "180px", height: "auto", marginBottom: "0px" }} /> :
        <h3>{item.Model ?? ""}</h3>}
      <Typography sx={{

        color: "black"
      }}>{item.Brand ?? "N/A"}</Typography>
      <Typography sx={{ marginTop: "5px", color: "black" }}>{item.Model ?? "N/A"}</Typography>
      <Typography noWrap
        sx={{ marginTop: "5px", color: "black" }}>{`${item.TireSize} ${item.loadIndex} ${item.speedRating}`}</Typography>
    </Grid>
    <Grid item xs={12} lg={2} pr={{ md: 1 }}>
      <Grid item xs={12}>
        <Typography variant="body2" sx={{
          fontSize: "14px",
          color: "black"
        }}>UTQG: <b>{item.Utqg ?? "N/A"}</b></Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" sx={{
          fontSize: "14px",
          color: "black"
        }}>SideWall: <b>{item.SideWall ?? "N/A"}</b></Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" sx={{
          fontSize: "14px",
          color: "black"
        }}>Warranty: <b>{item.Warranty ?? "N/A"}</b></Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" sx={{
          fontSize: "14px",
          color: "black"
        }}>MFR Part
          No: <b>{item.MfrPartNo ?? "N/A"}</b></Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="body2" sx={{
            fontSize: "14px",
            color: "black"
          }}>OE: <b>{(item?.oEDescription && item?.oEDescription?.length > 0) ? item.oEDescription : "N/A"}</b></Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" sx={{
          fontSize: "14px",
          color: "black"
        }}>Run
          Flat: <b>{(item?.RunFlat) ? "Yes" : "No"}</b></Typography>
      </Grid>
    </Grid>
    <Grid item xs={12} lg={2} px={{ md: 1 }}>
      <Box display="flex" alignItems="center" width="100%">
        <Typography fontWeight="bold" fontSize="24px" color="#E7131A">
          {`$${item.UnitPrice.toFixed(2) ?? '-'}`}
        </Typography>
        <Typography fontWeight="bold" fontSize="18px" color="#E7131A"
          sx={{ ml: 0.5 }}>
          {((item.unitOfMeasureDescription) && (item.unitOfMeasureDescription.length > 0)) ? (item.unitOfMeasureDescription.toLowerCase()) : `ea`}
        </Typography>
        {/* WHOLESALE Price Description */}
        {isUser && item.alternatePrice !== "0" &&
          <Typography fontWeight="bold" fontSize="16px" color="#E7131A"
            sx={{ ml: 0.5 }}>
            {item.priceDescription}
          </Typography>
        }
      </Box>

      {/* WHOLESALE Alternate Price  */}
      {isUser && item.alternatePrice !== "0" &&
        <Box display="flex" alignItems="center">
          <Typography fontWeight="bold" fontSize="20px" color="green">
            {`$${parseFloat(item.alternatePrice ?? "").toFixed(2) ?? ""}`}
          </Typography>
          <Typography fontWeight="bold" fontSize="16px" color="green"
            sx={{ ml: 0.5 }}>
            {((item.unitOfMeasureDescription) && (item.unitOfMeasureDescription.length > 0)) ? (item.unitOfMeasureDescription.toLowerCase()) : `ea`}
          </Typography>
          <Typography fontWeight="bold" fontSize="14px" color="green"
            sx={{ ml: 0.5 }}>
            {item.alternatePriceDescription}
          </Typography>
        </Box>
      }
      {/* Tax Display */}
      {item.additionalTax1 && item.additionalTax1 !== "0" &&
        <Box display="flex" alignItems="center">
          <Typography fontWeight="bold" fontSize="16px" color="#E7131A">
            {`+$${parseFloat(item.additionalTax1).toFixed(2) ?? ""}`}
          </Typography>
          <Typography fontWeight="bold" fontSize="12px" color="#E7131A"
            sx={{ ml: 0.5 }}>
            FET
          </Typography>
        </Box>
      }
    </Grid>
    {stock && stock.length > 0 && <Grid item xs={12} lg={2} pr={{ md: 1, lg: 1 }}>






      <Typography sx={{
        mb: 1,
        minHeight: 0,
        display: 'flex',
        color: "black",
      }}>
        <LocationOnIcon />
        <span style={{ fontSize: "16px" }}>
          {stock[parseInt(locationQuantity, 10)]?.locationObj.name} {" : "}
          <span
            style={{
              color: stock[parseInt(locationQuantity, 10)]?.qty === 0 ? "blue" : "inherit",
            }}
          >
            {stock[parseInt(locationQuantity, 10)]?.qty}
          </span>
        </span>


      </Typography>

      <Typography
        sx={{
          fontSize: "14px",
          mb: 1,
          display: "flex",
          visibility: totalQuantity == 0 || stock[parseInt(locationQuantity, 10)]?.qty === 0 ? "visible" : "hidden",
          color: "black",
        }}
      >
        <span
          style={{
            color: "blue",
            animation: "blink 3s linear infinite", // CSS animation for blinking
          }}
        >
          Available 1-2 Days
        </span>

      </Typography>

      <Box
        onMouseEnter={(e) => setWarehouseAnchorEl(e.currentTarget)}
        onMouseLeave={() => setWarehouseAnchorEl(null)}
        sx={{
          position: "relative",
          width: "100%",
          mt: "12px",
          height: 56,
          display: "flex",
          alignItems: "center",
          border: "1px solid rgba(0,0,0,0.23)",
          borderRadius: "4px",
          px: "14px",
          pr: "48px", // ✅ IMPORTANT FIX
          cursor: "pointer",
          backgroundColor: "#fff",
          transition: "border-color 0.15s ease",

          "&:hover": {
            borderColor: "black",
          },

          "&:hover .dropdown-icon": {
            animation: "none",
            transform: "scale(1.25)",
            filter: "drop-shadow(0 0 10px rgba(25,118,210,0.9))",
          },

          "@keyframes arrowGlow": {
            "0%": {
              filter: "drop-shadow(0 0 3px rgba(25,118,210,0.4))",
            },
            "50%": {
              filter: "drop-shadow(0 0 8px rgba(25,118,210,0.75))",
            },
            "100%": {
              filter: "drop-shadow(0 0 3px rgba(25,118,210,0.4))",
            },
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: "16.5px",          // 🔑 MATCH MUI
            pb: "16.5px",          // 🔑 MATCH MUI
            boxSizing: "border-box",
            pointerEvents: "none",
          }}
        >

          <Typography
            sx={{
              fontSize: "0.75rem",
              color: "text.secondary",
              lineHeight: 1,
            }}
          >
            Regional
          </Typography>

          <Typography sx={{ fontWeight: 500 }}>
            {totalQuantity + (showExternal ? item.externalinventory || 0 : 0)}
          </Typography>

        </Box>

        {/* Glowing arrow */}
        <ArrowDropDownIcon
          className="dropdown-icon"
          sx={{
            position: "absolute",
            right: 8,
            fontSize: 34,
            color: "primary.main",
            pointerEvents: "none",
            animation: "arrowGlow 1.6s ease-in-out infinite",
            transition: "transform 0.2s ease, filter 0.2s ease",
          }}
        />
      </Box>


      <Popover
        open={isWarehouseHoverOpen}
        anchorEl={warehouseAnchorEl}
        onClose={() => setWarehouseAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        disableRestoreFocus
        disableScrollLock
        sx={{ pointerEvents: "none" }} // hover-only
      >
        <Box sx={{ minWidth: 220 }}>
          {stock.map((oneStock: Stock, index: number) => (
            oneStock.locationObj.name && (
              <Box
                key={index}
                sx={{
                  px: 2,
                  py: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  opacity: oneStock.qty === 0 ? 0.5 : 1,
                }}
              >
                <span>
                  {oneStock.externalInventory
                    ? "Special Order"
                    : oneStock.locationObj.name}
                </span>
                <strong>{oneStock.qty ?? 0}</strong>
              </Box>
            )
          ))}

          {showExternal && (
            <Box
              sx={{
                px: 2,
                py: 1,
                display: "flex",
                justifyContent: "space-between",
                opacity: item.externalinventory === 0 ? 0.5 : 1,
              }}
            >
              <span>Special Order</span>
              <strong>{item.externalinventory ?? 0}</strong>
            </Box>
          )}
        </Box>
      </Popover>


    </Grid>}
    <Grid item xs={12} lg={2} pr={{ md: 1 }}>
      <FormControl fullWidth sx={{
        borderRadius: "5px",
        color: "black",
        marginBottom: "5px",
        width: "100%"
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', width: "100%", paddingBottom: "5px" }} className="showOnWeb">
          <div style={{ display: "flex", flexDirection: "column", width: "100%", minWidth: 125, height: "55px" }}>
            <button
              disabled={buttonState(item) === "ADDED TO CART"}
              type="button"
              className="theme-btn theme-btn-eight"
              onClick={handleAddServices}
              style={{
                height: "55px",
                padding: "2px",
                fontSize: "10px",
                fontWeight: 500,
                backgroundColor:
                  buttonState(item) === "ADDED TO CART" ? "darkgray" : "#E7131A",
              }}
            >
              {buttonState(item)}
            </button>

          </div>

        </Box>

      </FormControl>
      <TextField
        id="demo-simple-select"
        className="CustomQuanity"
        label="Quantity"
        value={quantity}
        sx={{
          width: "100%",
          '& .MuiInputLabel-root': { // Targets the label
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            fontSize: "0.75rem",
            top: "-5px",
            textAlign: "center",
          },
          '& .MuiOutlinedInput-root': { // Targets the input field
            textAlign: "center",
            '& input': {
              textAlign: "center", // Ensures input text is centered
            },
            '& fieldset': {
              margin: '0 auto', // Center the fieldset horizontally
            },
          },
        }}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton onClick={decreaseQuantity} size="small">
                <RemoveIcon />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={increaseQuantity} size="small">
                <AddIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{ shrink: true }}
      />
      <Box
        sx={{
          marginTop: "15px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          gap: 1
        }}
        onClick={async () => {
          // if already compared → just remove it (no API call)
          if (isCompared) {
            dispatch(toggleCompare(item));
            return;
          }
          // 👇 Fetch optional services ONCE here
          const apiResponse: any = await GetAdditionalServices(
            item.SystemId,
            "1",               // quantity
            customerId ?? "", // your user’s systemId
            false            // isCustom
          );

          // 👇 Attach services to the item BEFORE dispatch
          const itemWithServices = {
            ...item,
            optionalServices: apiResponse?.Data ?? []
          };

          dispatch(toggleCompare(itemWithServices));
        }}
      >
        {isCompared ? (
          <CheckBoxIcon sx={{ color: "#E7131A" }} />
        ) : (
          <CheckBoxOutlineBlankIcon sx={{ color: "black" }} />
        )}

        <Typography sx={{ fontSize: 14, color: "black" }}>
          Compare
        </Typography>
      </Box>



      <Box sx={{ display: 'flex', alignItems: 'center', width: "100%", paddingBottom: "5px", paddingTop: "25px" }} className="showOnMobile">
        <div style={{ display: "flex", flexDirection: "column", width: "100%", minWidth: 150, height: "55px" }}>
          <button
            disabled={(buttonState(item) === "ADDED TO CART") /**((buttonState(item) === "ADDED TO CART") || (buttonState(item) === "OUT OF STOCK")) */}
            type="button"
            className="theme-btn theme-btn-eight"
            onClick={handleAddServices}
            style={(buttonState(item) === "ADDED TO CART") ? {
              height: "55px",
              padding: '2px',
              backgroundColor: "darkgray"
            } : { height: "55px", padding: '2px', backgroundColor: "#E7131A" }}
          >
            {buttonState(item)}
          </button>
        </div>

      </Box>
    </Grid>
    {error && <Alert setError={setError} severity="error" text={errorMessage} />}
    {optionalServices?.length !== 0 &&
      <OptionalServicesModal product={newCartItem} updateCart={updateCart} calculateTotal={calculateTotal}
        open={open} setOpen={setOpen}
        fields={newCartItem?.services && newCartItem?.services.length !== 0 ? newCartItem.services : optionalServices}
        setOptions={setOptions} quantity={quantity} isCart={false}
        showConfirmationModal={showConfirmationModal}
        setShowConfirmationModal={setShowConfirmationModal} />}
  </Grid>

  )

}

export default TireDetailsPage;
